/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Flex,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useEditCustomer,
  useGetCustomerDetails,
} from "../../services/customer-api";
import {
  useLookupCurrency,
  useLookupDesignations,
} from "../../services/lookups-queries";
import CustomerInformation from "./addCustomer/customer-information";
import Accounts from "./addCustomer/accounts";
import ContactPerson from "./addCustomer/contact-persons";
import ReplenishmentModels from "./addCustomer/replenishment-models";
import Contracts from "./addCustomer/contracts";
import Insurance from "./addCustomer/insurance";
import EscalationGroups from "./addCustomer/escalation-groups";
import Summary from "./addCustomer/summary";
import OfferedServices from "./addCustomer/offered-services";
import { ModifyCustomerDetails } from "./helper";
import { emptyCustomer } from "./constants";

const steps = [
  { title: "Information" },
  { title: "Accounts" },
  { title: "Contacts" },
  { title: "Insurance" },
  { title: "Models" },
  { title: "Contracts" },
  { title: "Offered Services" },
  { title: "Escalations" },
];
export default function EditCustomer() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [customer, setCustomer] = useState({ ...emptyCustomer });
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const params = useParams();
  const navigate = useNavigate();

  const { data: currencyListRes, isPending: gettingCurrencyList } =
    useLookupCurrency();

  const {
    mutate: editCustomer,
    data: editCustomerRes,
    isPending: editingCustomer,
    error: editCustomerError,
  } = useEditCustomer();

  const {
    data: designations,
    isPending: gettingDesignations,
    error: designationError,
  } = useLookupDesignations();

  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    isPending: gettingCustomerDetails,
    reset: resetCustomerDetails,
  } = useGetCustomerDetails();

  useEffect(() => {
    if (params.customerId) {
      getCustomerDetails(params.customerId);
    }
  }, []);

  useEffect(() => {
    if (editCustomerRes) {
      navigate(Paths.customers);
      return;
    }

    if (designations?.data) {
      setDesignationList(
        designations.data.map((des) => ({
          id: des.description,
          text: des.description,
        }))
      );
    }

    if (customerDetailsRes && currencyListRes && designations) {
      const _customer = ModifyCustomerDetails(
        customerDetailsRes.data,
        currencyListRes.data,
        designations.data
      );

      setCustomer({ ..._customer });
      reset({
        clientId: _customer.clientId,
        name: _customer.name,
        shortName: _customer.shortName,
        customerType: _customer.customerType,
        customerCode: customer.customerCode,
        status: _customer.status,
        hasSeparateDispenseCount: _customer.hasSeparateDispenseCount,
        requiresEVhr: _customer.requiresEVhr,
      });
      resetCustomerDetails();
    }
  }, [
    editCustomerRes,
    editCustomerError,
    designations,
    designationError,
    customerDetailsRes,
    currencyListRes,
  ]);
  console.log(customer);
  const updateCustomerInfo = (information) => {
    const _customer = {
      ...customer,
      clientId: information.clientId,
      name: information.name,
      shortName: information.shortName,
      customerType: information.customerType,
      customerCode: information.customerCode,
      status: information.status,
      hasSeparateDispenseCount: information.hasSeparateDispenseCount,
      requiresEVhr: information.requiresEVhr,
    };
    setCustomer(_customer);
  };

  const getCustomerInformation = useMemo(
    () => ({
      clientId: customer.clientId,
      name: customer.name,
      shortName: customer.shortName,
      customerType: customer.customerType,
      customerCode: customer.customerCode,
      status: customer.status,
      hasSeparateDispenseCount: customer.hasSeparateDispenseCount,
      requiresEVhr: customer.requiresEVhr,
    }),
    [customer]
  );

  const updateAccounts = (accounts) => {
    const _customer = {
      ...customer,
      accounts,
    };
    setCustomer(_customer);
  };

  const getAccounts = useMemo(() => [...customer.accounts], [customer]);

  const updateContactPersons = (contactPersons) => {
    const _customer = {
      ...customer,
      contactPersons,
    };
    setCustomer(_customer);
  };

  const getContactPersons = useMemo(
    () => [...customer.contactPersons],
    [customer]
  );

  const updateReplenishmentModels = (replenishmentModels) => {
    const _customer = {
      ...customer,
      replenishmentModels,
    };
    setCustomer(_customer);
  };

  const getReplenishmentModels = useMemo(
    () =>
      customer.replenishmentModels.map((elm) => ({ ...elm, expanded: false })),
    [customer]
  );

  const updateInsuranceLimits = (insuranceLimits) => {
    const _customer = {
      ...customer,
      insuranceLimits,
    };
    setCustomer(_customer);
  };

  const getInsuranceLimits = useMemo(
    () => [...customer.insuranceLimits],
    [customer]
  );
  const updateContracts = (contracts) => {
    const _customer = {
      ...customer,
      contracts,
    };
    setCustomer(_customer);
  };

  const getContracts = useMemo(() => [...customer.contracts], [customer]);

  const getOfferedServices = useMemo(
    () => [...customer.offeredServices],
    [customer]
  );

  const updateServices = (services) => {
    const _customer = {
      ...customer,
      offeredServices: services,
    };
    setCustomer(_customer);
  };
  const getEscalationGroups = useMemo(
    () => [...customer.escalationGroups],
    [customer]
  );
  const updateEscalationGroup = (escalationGroups) => {
    const _customer = {
      ...customer,
      escalationGroups,
    };
    setCustomer(_customer);
  };
  const {
    handleSubmit,
    control,
    trigger,
    watch,
    resetField,
    reset,
    getValues,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: { ...getCustomerInformation },
  });
  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);

  return (
    <>
      {gettingCustomerDetails ||
      editingCustomer ||
      gettingCurrencyList ||
      gettingDesignations ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Customers", link: Paths.customers },
            { text: "Edit Customer", isCurrentPage: true },
          ]}
        />

        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              onClick={() => {
                if (activeStep === 1) {
                  updateCustomerInfo(getValues());
                }
                setActiveStep(index + 1);
              }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
        {!customer.clientId && !isDirty ? (
          <></>
        ) : (
          <Flex w="100%" mt="20px">
            <Card flexDirection="column" w="100%">
              <CardBody>
                <div className="add-location-form">
                  {activeStep === 1 ? (
                    <form>
                      <CustomerInformation
                        customerObject={getCustomerInformation}
                        onNextStep={(information) => {
                          setActiveStep(2);
                          updateCustomerInfo(information);
                        }}
                        handleSubmit={handleSubmit}
                        control={control}
                        errors={errors}
                        watch={watch}
                        resetField={resetField}
                      />
                    </form>
                  ) : activeStep === 2 ? (
                    <Accounts
                      accounts={getAccounts}
                      onNextStep={(localAccountsList) => {
                        setActiveStep(3);
                        updateAccounts(localAccountsList);
                      }}
                      onPrevStep={(localAccountsList) => {
                        setActiveStep(1);
                        updateAccounts(localAccountsList);
                      }}
                      addData={(data) => {
                        updateAccounts(data);
                      }}
                    />
                  ) : activeStep === 3 ? (
                    <ContactPerson
                      designationList={designationList}
                      contactPersons={getContactPersons}
                      onNextStep={(contactPersonList) => {
                        setActiveStep(4);
                        updateContactPersons(contactPersonList);
                      }}
                      onPrevStep={(contactPersonList) => {
                        setActiveStep(2);
                        updateContactPersons(contactPersonList);
                      }}
                      addData={(data) => {
                        updateContactPersons(data);
                      }}
                    />
                  ) : activeStep === 4 ? (
                    <Insurance
                      currencies={currencyListRes?.data || []}
                      insuranceLimits={getInsuranceLimits}
                      onNextStep={(insuranceLimit) => {
                        setActiveStep(5);
                        updateInsuranceLimits(insuranceLimit);
                      }}
                      onPrevStep={(insuranceLimit) => {
                        setActiveStep(3);
                        updateInsuranceLimits(insuranceLimit);
                      }}
                      addData={(data) => {
                        updateInsuranceLimits(data);
                      }}
                    />
                  ) : activeStep === 5 ? (
                    <ReplenishmentModels
                      currencies={currencyListRes?.data || []}
                      models={getReplenishmentModels}
                      onNextStep={(replenishmentModels) => {
                        setActiveStep(6);
                        updateReplenishmentModels(replenishmentModels);
                      }}
                      onPrevStep={(replenishmentModels) => {
                        setActiveStep(4);
                        updateReplenishmentModels(replenishmentModels);
                      }}
                      addData={(data) => {
                        updateReplenishmentModels(data);
                      }}
                    />
                  ) : activeStep === 6 ? (
                    <Contracts
                      contracts={getContracts}
                      currencies={currencyListRes?.data || []}
                      onPrevStep={(contracts) => {
                        setActiveStep(5);
                        updateContracts(contracts);
                      }}
                      onNextStep={(contracts) => {
                        setActiveStep(7);

                        updateContracts(contracts);
                      }}
                      addData={(data) => {
                        updateContracts(data);
                      }}
                    />
                  ) : activeStep === 7 ? (
                    <OfferedServices
                      services={getOfferedServices}
                      currencies={currencyListRes?.data || []}
                      onPrevStep={(services) => {
                        setActiveStep(6);
                        updateServices(services);
                      }}
                      onNextStep={(services) => {
                        setActiveStep(8);
                        updateServices(services);
                      }}
                      addData={(data) => {
                        updateServices(data);
                      }}
                    />
                  ) : activeStep === 8 ? (
                    <EscalationGroups
                      escalationGroups={getEscalationGroups}
                      onPrevStep={(escalationGroups) => {
                        setActiveStep(7);
                        updateEscalationGroup(escalationGroups);
                      }}
                      onNextStep={(escalationGroups) => {
                        updateEscalationGroup(escalationGroups);
                        if (isValid) {
                          setActiveStep(9);
                        } else {
                          setActiveStep(1);
                          setTriggerValidation(true);
                        }
                      }}
                      addData={(data) => {
                        updateEscalationGroup(data);
                      }}
                    />
                  ) : activeStep === 9 ? (
                    <Summary
                      editing
                      customer={customer}
                      onPrevStep={() => {
                        setActiveStep(8);
                      }}
                      onCreateCustomer={(customerPayload) => {
                        editCustomer({
                          ...customerPayload,
                          id: params.customerId,
                        });
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </CardBody>
            </Card>
          </Flex>
        )}
      </div>
    </>
  );
}
